import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';

import { FsMessage } from '@firestitch/message';

import { SessionService } from '@app/core';
import { TermsService } from '@app/terms/services';


@Component({
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RouterOutlet],
})
export class TermsComponent implements OnInit {

  constructor(
    private _sessionService: SessionService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _message: FsMessage,
    private _termsService: TermsService,
  ) { }

  public ngOnInit(): void {
    const redirect = this._route.snapshot.queryParams.redirect;

    if (redirect) {
      this._termsService.redirect = redirect;
    }

    if (this._sessionService.termsApproval.isParentTermsRequired) {
      this._router.navigate(['parent'], { relativeTo: this._route });
    } else if (this._sessionService.termsApproval.isOrganizationTermsRequired) {
      this._router.navigate(['organization'], { relativeTo: this._route });
    } else if (this._sessionService.termsApproval.isCadPadRequired) {
      this._router.navigate(['cad-pad'], { relativeTo: this._route });
    } else if (this._sessionService.termsApproval.isUsdPadRequired) {
      this._router.navigate(['usd-pad'], { relativeTo: this._route });
    } else {
      this._router.navigateByUrl(this._termsService.redirect || '/');
      this._termsService.redirect = '';
      this._message.success(`Welcome ${this._sessionService.account().firstName}`);
    }
  }

}
